// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1VP4n","footer":"ModalFilter_footer__3EK28"};